import * as m from "@paraglide/messages"
import "./styles.css"
import { useRouteShellContext } from "@components/routeShellContext"

export function CompanyStory() {
  const { locale } = useRouteShellContext()
  return (
    <section className="story">
      <h2>{m.company_ourCompany_label({}, { locale: locale })}</h2>
      <p>{m.company_ourCompany_pointOne({}, { locale: locale })}</p>
      <p>{m.company_ourCompany_pointTwo({}, { locale: locale })}</p>
      <p>{m.company_ourCompany_pointThree({}, { locale: locale })}</p>
    </section>
  )
}

export default CompanyStory
